var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.3,9.8h13.2c0.8,0,1.5,0.7,1.5,1.5v10.3c0,0.8-0.7,1.5-1.5,1.5H5.3c-0.8,0-1.5-0.7-1.5-1.5V11.2 C4,10.4,4.6,9.8,5.3,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.9,9.8V6.1l0,0c0-2.8,2.3-5.2,5.1-5.2c2.8,0,5.1,2.2,5.1,5.1v3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,14.9v2.9"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12,
    cy: 15.3,
    r: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.b0fd9494dba4ea2c1248999e1b5ed44c.svg";
export { ForwardRef as ReactComponent };